import * as actions from '../constants'


export function get_nav(navdata) {
    return {
        type: actions.NAVDATA,
        navdata
    }
}
